import { select } from 'redux-saga/effects';
import { Page } from '@distribute/shared/types';
import { pagesModel } from '../../pages';

export function* getPageIdByContentId(contentId: number) {
  const pages: Page[] = yield select(pagesModel.selectors.selectPages);

  return pages.find((p) => p.content.id === contentId)?.id;
}
